export const buildHoursPrompt = ({
  place,
  hours,
  group,
  suggestions,
}) => `
You are a professional travel writer creating a realistic, up-to-date hourly itinerary.

Destination: ${place}
Duration: ${hours} hours
Traveler Type: ${group}
${suggestions ? `Preferences: ${Array.isArray(suggestions) ? suggestions.join(", ") : suggestions
    }` : ""}

STYLE:
- Soft, friendly, instructional tone.
- Use action verbs (Visit, Walk, Explore, Try, Head to).
- Keep language simple and clear.
- Keep recommendations practical and realistic.
- Paragraphs only. No emojis.

STRICT FORMAT (follow exactly):

TITLE: ${place} Hourly Itinerary

For each hour, use this structure exactly:

## Hour 1
One paragraph (3–4 sentences).
Location: Place Name

Repeat this format sequentially until:

## Hour ${hours}

After all hours write:

Estimated Budget: India: ₹ <min> - ₹ <max>

## Transportation
One practical paragraph about moving efficiently around ${place} today.


IMPORTANT:
Always write the location on a new line using exactly:
Location: Place Name

END
`;